import { render, staticRenderFns } from "./_EditProduct.vue?vue&type=template&id=7468115d&scoped=true&"
import script from "./_EditProduct.vue?vue&type=script&lang=js&"
export * from "./_EditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7468115d",
  null
  
)

export default component.exports